import { Component, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatSnackBar } from '@angular/material';
import { FormControl, Validators, FormGroup, ValidationErrors } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { UiService } from '../../services/ui.service';
import { Router } from '@angular/router';
import { DataSourceService } from '../../services/data-source.service';
import { Employee } from '@akiba/models_bimbo';
import { LogicService } from './../../services/logic.service';

export interface DialogData {
  message: string;
  cancelButton: string;
  confirmButton: string;
}


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  model: any = { email: '', employeeNumber: '', password: '', passwordConf: '', seniorityDate: new Date() };
  listener: Subscription;
  error: string = '';
  passwordConfirmation: string;
  dataEmpleado: Employee;
  passForm = new FormGroup({
    passConfirmation: new FormControl('', [Validators.required]),
    pass: new FormControl('', [Validators.required,
    Validators.minLength(8),
    Validators.maxLength(25),
    Validators.pattern('^(?=.*[A-z])(?=.*)(?=.*[$@$!%*?&\d])([A-Za-z\d$@$!%*?&]|[^ ]){8,8}$')]),
  }, { validators: this.checkPasswords.bind(this) });


  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, public dialogRef: MatDialogRef<ChangePasswordComponent>, 
  public snackBar: MatSnackBar, public logicService: LogicService, private dataService: DataSourceService, 
  private authService: AuthenticationService, private router: Router, private ui: UiService) {

  }

  ngOnInit() {
    const authUser = this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    if (authUser) {
      if (authUser.uid.length > 8) {
        this.model.email = authUser.uid;
      } else {
        this.model.employeeNumber = authUser.uid;
        this.model.email = '';
      }
    }
  }

  save() {
    const workInformation = this.logicService.dataManager.principalDataLoader.employee.workInformation;
    this.model.seniorityDate = workInformation.seniorityDate.toISOString();
    this.passwordConfirmation = this.passForm.controls.passConfirmation.value;
    this.model.password = this.passForm.controls.pass.value;
    this.model.passwordConf = this.passForm.controls.passConfirmation.value;
    this.authService.signIn(this.model).then(result => {
      if (!result) {
        console.log('result Error');
        this.error = "Ocurrio un error.";
      } else {
        this.dialogRef.close();
        this.snackBar.open('Contraseña actualizada', null, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });
      }

    }).catch(error => {
      this.error = error;
    });
  }

  checkPasswords(formGroup: FormGroup): ValidationErrors | null {
    const { value: pass } = formGroup.get('pass');
    const { value: passConfirmation } = formGroup.get('passConfirmation');
    return pass === passConfirmation ? null : { passwordNotMatch: true };
  }
}
